import PropertyAddList from "containers/property/PropertyAddList";
import { Modal } from "react-bootstrap";

function PropertyAddModal({
    isAuthenticated,
    user,
    show,
    filter,
    data,
    updateTableState,
    saveForm,
    saveRecord,
    deleteRecord,
    cityscopeOptions,
    suburbOptions,
    validateRelatedRecord,
    propertyid,
    onClose,
}) {

    return (
        <Modal id="property-add-modal" show={show} onHide={onClose} dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title>Add Properties</Modal.Title>
            </Modal.Header>
            <Modal.Body id="property-add-modal-body">
                <PropertyAddList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    saveForm={saveForm}
                    user={user}
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    validateRelatedRecord={validateRelatedRecord}
                    propertyid={propertyid}
                    suburbOptions={suburbOptions}
                    cityscopeOptions={cityscopeOptions}
                />
            </Modal.Body>
        </Modal>
    );
}
export default PropertyAddModal;